// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
// Selectors
import { selectFocusModeEnabled } from 'app/store/AppUI/AppUI.selectors';
// Mui
import { Tooltip } from '@mui/material';
// Icons
import { Fullscreen as FullscreenIcon, FullscreenExit as FullscreenExitIcon } from '@mui/icons-material';
// Components
import { Button, IconButton } from 'app/components/Mui';
// Hooks
import useFullscreenFocusMode from 'app/hooks/useFullscreenFocusMode';

type Props = {
  isHidden?: boolean;
}

const FocusModeButton = ({
  // Props
  isHidden
}:Props) => {
  const dispatch = useAppDispatch();
  // State
  const focusModeEnabled = useAppSelector(selectFocusModeEnabled);

  const { handleClick } = useFullscreenFocusMode();

  const onClick = () => {
    if (!focusModeEnabled) dispatch(MixpanelActions.handleCaseWorkspaceFocusModeEnterClick());
    handleClick();
  }

  const label = focusModeEnabled ? 'Exit focus mode' : 'Enter focus mode';
  const icon = focusModeEnabled ? <FullscreenExitIcon /> : <FullscreenIcon /> ;

  if ( isHidden ) return (
    <Button
      name="Focus mode"
      onClick={onClick}
      variant="outlined"
      fullWidth
    >{label}</Button>
  );
  return (
    <Tooltip title={label}>
      <IconButton
        name="Focus mode"
        onClick={onClick}
      >{icon}</IconButton>
    </Tooltip>
  )
}

export default FocusModeButton